import React from 'react';

const TextareaField = ({
  input,
  placeholder,
}) => {
  return (
    <textarea
      {...input}
      className='form-control'
      type="text"
      placeholder={placeholder}
    />
  )
}

export default TextareaField;


// WEBPACK FOOTER //
// ./master/jsx/components/Common/TextareaField.jsx